import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSort } from '../redux/slices/filterSlice';
import { useOutsideClick } from '../hooks/useOutsideClick';
import { SortPropertyEnum } from '../@types/enums';

type SortItem = {
  name: string;
  sortProperty: SortPropertyEnum;
};

export const sorting: SortItem[] = [
  { name: 'популярности убыванию', sortProperty: SortPropertyEnum.RATING_DESC },
  {
    name: 'популярности возрастание',
    sortProperty: SortPropertyEnum.RATING_ASC,
  },
  { name: 'цене убыванию', sortProperty: SortPropertyEnum.PRICE_DESC },
  { name: 'цене возрастанию', sortProperty: SortPropertyEnum.PRICE_ASC },
  { name: 'алфавиту убыванию', sortProperty: SortPropertyEnum.TITLE_DESC },
  { name: 'алфавиту возрастанию', sortProperty: SortPropertyEnum.TITLE_ASC },
];

export function SortPopup() {
  const [popupActive, setPopupActive] = useState(false);
  const sortRef = useRef<HTMLDivElement>(null);

  const onClose = () => {
    setPopupActive(false);
  };

  useOutsideClick({
    elementRef: sortRef,
    onOutsideClick: onClose,
    enabled: popupActive,
  });

  const sort = useSelector((state: any) => state.filter.sort);
  const dispatch = useDispatch();

  function onClickSort(sortItem: SortItem) {
    dispatch(setSort(sortItem));
    setPopupActive(false);
  }
  // FIX sort undefined
  if (!sort) {
    return <div>ERROR</div>;
  }

  return (
    <div ref={sortRef} className="sort">
      <div className="sort__label">
        <svg
          width="10"
          height="6"
          viewBox="0 0 10 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ transform: `rotate(${popupActive ? 180 : 0}deg)` }}
        >
          <path
            d="M10 5C10 5.16927 9.93815 5.31576 9.81445 5.43945C9.69075 5.56315 9.54427 5.625 9.375 5.625H0.625C0.455729 5.625 0.309245 5.56315 0.185547 5.43945C0.061849 5.31576 0 5.16927 0 5C0 4.83073 0.061849 4.68424 0.185547 4.56055L4.56055 0.185547C4.68424 0.061849 4.83073 0 5 0C5.16927 0 5.31576 0.061849 5.43945 0.185547L9.81445 4.56055C9.93815 4.68424 10 4.83073 10 5Z"
            fill="#2C2C2C"
          />
        </svg>
        <b>Сортировка по:</b>
        <span onClick={() => setPopupActive(!popupActive)}>{sort.name}</span>
      </div>
      {popupActive && (
        <div className="sort__popup">
          <ul>
            {sorting.map((sortItem, index) => (
              <li
                key={index}
                onClick={() => onClickSort(sortItem)}
                className={
                  sort.sortProperty === sortItem.sortProperty ? 'active' : ''
                }
              >
                {sortItem.name}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
